import { PAYMENT_USING_GIFTCARD, RESET_GIFT_CARD_TRANSACTION, GIFTCARD_PURCHASE_STATUS, RESET_PURCHASE_STATUS, } from '../../constants';
export function giftCardAction(payload) {
    return {
        type: PAYMENT_USING_GIFTCARD,
        payload,
    };
}
export function resetGiftCardTransactionAction() {
    return {
        type: RESET_GIFT_CARD_TRANSACTION,
    };
}
export function giftCardPurchaseStatusAction(payload) {
    return {
        type: GIFTCARD_PURCHASE_STATUS,
        payload,
    };
}
export function resetGiftCardPurchaseStatusAction() {
    return {
        type: RESET_PURCHASE_STATUS,
    };
}
